export const meta = {
  title: '隐私政策 | CADCraft AI',
  description: 'CADCraft AI（cadcraft.org）如何处理访客、账号和使用信息。',
  updated_at: '2026-10-20',
};

## 关于本政策

CADCraft AI 运营 cadcraft.org，这是一个关于开源 CAD 软件 CADCraft 的独立指南站，提供 CADCraft 下载与安装指南、与 Autodesk AutoCAD 的对比、教程，以及托管的 CADCraft 网页版。本政策说明我们处理哪些信息以及原因。联系方式：[support@cadcraft.org](mailto:support@cadcraft.org)。

## 在线版中的图纸

CADCraft 在线版在你的浏览器中运行。使用免费版时，你在其中创建或打开的图纸**不会上传到我们的服务器**：自动保存会把最近的图纸保存在本设备的浏览器存储中，“保存”和“导出”会把文件直接下载到你的电脑。清除浏览器数据会删除这些图纸。

如果你订阅了 **CADCraft 在线版 Pro**，你的图纸还会保存到你账户下的云存储（Cloudflare R2），以便在其他设备上打开。只有你本人可以访问；如果你为某张图纸开启了只读分享链接，拿到链接的人可以打开它的副本，直到你关闭分享。历史版本保留 30 天。删除图纸会删除它的所有版本。如果你要求删除账户，我们会一并删除你的全部云端图纸。

## 下载

下载按钮指向 GitHub 上的 CADCraft 官方发布页。下载文件时，GitHub 会依据其[隐私声明](https://docs.github.com/en/site-policy/privacy-policies/github-general-privacy-statement)接收你的请求。

## 账号信息

使用本站无需账号。如果你选择注册，我们会保存你的邮箱、姓名、头像（若使用 Google 登录）和登录会话。

## 技术与统计数据

与大多数网站一样，我们的托管服务商（Cloudflare）会处理 IP 地址、浏览器和设备信息以及请求日志，以提供和保护网站。我们可能使用注重隐私的统计工具了解哪些页面有用，这些工具可能使用 Cookie 或类似技术。我们自己的统计会记录页面浏览、点击下载等步骤，以及在线版中你打开或保存的文件类型和大小，但从不记录文件内容。

## 广告与 Cookie

我们通过展示广告来维持本站的免费运营。第三方供应商（包括 Google）会使用 Cookie，根据您此前对本站及其他网站的访问投放广告。Google 使用广告 Cookie，使其及其合作伙伴能够根据您对本站和/或互联网上其他网站的访问向您投放广告。您可以通过访问 [Google 广告设置](https://www.google.com/settings/ads) 关闭个性化广告；也可以访问 [https://www.aboutads.info](https://www.aboutads.info) 关闭部分第三方供应商用于个性化广告的 Cookie。如果您位于欧洲经济区、英国或瑞士，我们会在设置广告 Cookie 之前征求您的同意，您可以随时更改或撤回该同意。关于 Google 如何使用来自使用其服务的网站的信息，请见 [https://policies.google.com/technologies/partner-sites](https://policies.google.com/technologies/partner-sites)。

## 信息共享

我们不会出售你的个人信息。仅在帮助我们运营网站的服务商（托管、邮件、统计、广告）需要时，或法律要求时才会共享。第三方广告供应商可能会通过其自身的 Cookie 收集数据，详见上文所述。

## 你的选择

你可以随时发送邮件至 [support@cadcraft.org](mailto:support@cadcraft.org)，要求查看、更正或删除你的账号数据。你可以在浏览器设置中屏蔽或清除 Cookie。关于广告，你可以访问 [https://www.google.com/settings/ads](https://www.google.com/settings/ads) 和 [https://www.aboutads.info](https://www.aboutads.info) 关闭个性化广告。

## 变更

我们可能会更新本政策，页面顶部的日期为最新版本日期。
